import { node } from 'prop-types';

import { FREESHIPPING_SNACKBAR_DURATION } from '../constants';
import useEshopsEnvironment from '../../../hooks/use-eshops-environment';
import useFullFreeshipping from '../hooks/use-full-freeshipping';

/**
 * Component FullFreeshippingSwitcher
 * @param {Object} props - Props del componente
 * @param {React.ReactNode} [props.eshopsComponent] - Componente a mostrar en entorno de eshops
 * @param {React.ReactNode} [props.defaultComponent] - Componente por defecto a mostrar
 * @returns {React.ReactNode} Componente seleccionado según el entorno y la duración del snackbar
 */
const FullFreeshippingSwitcher = ({ eshopsComponent = undefined, defaultComponent = undefined }) => {
  const { isEshopsEnvironment } = useEshopsEnvironment();
  const { freeshippingSnackbarDuration } = useFullFreeshipping();

  return isEshopsEnvironment && freeshippingSnackbarDuration !== FREESHIPPING_SNACKBAR_DURATION.SHORT
    ? eshopsComponent
    : defaultComponent;
};

FullFreeshippingSwitcher.propTypes = {
  defaultComponent: node,
  eshopsComponent: node,
};

export default FullFreeshippingSwitcher;
